<!-- HOME PAGE -->
<div class="container">
  <!-- HEADER PAGE -->

  <!-- ROW TITLE AND CLIP -->
  <div fxLayout="row wrap" fxLayoutAlign="center center">
    <div fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="90" fxFlex.xs="90">

      <!-- COLONNE FLEX ILLUSTRATION RESPONSIVE -->
      <div class="rowdiv wrapper img404">
        <img class="img-responsive" src="../assets/medias/img/404.webp">
      </div>

      <!-- COLONNE FLEX MESSAGE -->
      <div class="msg404">
        404
      </div>

      <div class="sub404">
        <p>Looks like you're lost
          <br>
          Let us take you back
          <button mat-flat-button class="btn-start-hover color-3">
            <span class="a404" routerLink="/home">Home</span>
          </button>

        </p>
      </div>
    </div>
  </div>
</div>
